var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-page',{attrs:{"total":_vm.total,"page-size":_vm.page.size,"size":"small","show-elevator":"","show-total":""},on:{"on-change":_vm.pageIndexChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }